//https://github.com/marmelab/react-admin/blob/master/docs/Theming.md
import { useState } from 'react'
import {
  useResourceDefinitions,
  useSidebarState,
  useTranslate,
  usePermissions,
  MenuItemLink,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { MenuItem, Collapse, Grid } from '@material-ui/core'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import ListIcon from '@mui/icons-material/List'

const useStyles = makeStyles({
  icon: {
    width: '25px',
    minWidth: '25px',
  },
  arrowContainer: {
    paddingTop: '8px',
  },
  disableHover: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  externalLink: {
    all: 'unset',
    '&icon: ': {
      padding: '16px',
    },
  },
  font: {
    fontSize: '0.875rem',
    fontFamily: "'Source Sans Pro', sans-pro",
    color: 'rgba(0, 0, 0, 0.54)',
  },
})

//NOTE: we need to filter resources without icon because in App.js,
//we have resources without icons, that we needed to declare to initialize the data provider.
const MyMenu = () => {
  const [open] = useSidebarState()
  const resources = useResourceDefinitions()
  const { permissions } = usePermissions()
  const translate = useTranslate()
  const classes = useStyles()
  let [openedSubMenu, setOpenedSubMenu] = useState()
  if (!permissions) return null
  let to_render = []
  permissions.forEach((name) => {
    if (!resources[name]) {
      console.warn(`Missing menu ${name}`)
      return
    }
    if (resources[name].options.subMenu) {
      if (!to_render[resources[name].options.subMenu.name]) {
        to_render[resources[name].options.subMenu.name] = []
      }
      to_render[resources[name].options.subMenu.name].push(resources[name])
    } else {
      if (!to_render['none']) to_render['none'] = []
      to_render['none'].push(resources[name])
    }
  })

  return Object.keys(to_render).map((name, idx) => {
    if (name === 'none') {
      return to_render[name].map(({ options, name, icon }) => (
        <>
          {!options.path && (
            <MenuItemLink
              className={classes.disableHover}
              key={`menu-${options.label || name}-${idx}`}
              to={name}
              primaryText={
                <span className={classes.font}>
                  {translate(options.label || `resources.${name}.name`)}
                </span>
              }
              leftIcon={
                icon ? (
                  <img src={icon} className={classes.icon} />
                ) : (
                  <ListIcon />
                )
              }
            />
          )}
          {options.path && (
            <MenuItem
              className={classes.disableHover}
              key={`menu-path-${options.label || name}-${idx}`}
            >
              <a
                target={options.target | '_blank'}
                href={options.path}
                className={`${classes.externalLink} ${classes.font}`}
              >
                <Grid container spacing={5}>
                  <Grid item xs={2}>
                    {icon ? (
                      <img src={icon} className={classes.icon} />
                    ) : (
                      <ListIcon />
                    )}
                  </Grid>
                  <Grid item>
                    {translate(options.label || `resources.${name}.name`)}
                  </Grid>
                </Grid>
              </a>
            </MenuItem>
          )}
        </>
      ))
    }
    return to_render[name].map((resource, subIdx) => (
      <>
        {subIdx === 0 && (
          <MenuItem
            key={`submenu-${resource.options.subMenu.name}-${idx}-${subIdx}`}
            className={classes.disableHover}
            onClick={() => {
              setOpenedSubMenu((prev) => {
                if (prev === idx) return null

                return idx
              })
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={2}>
                {resource.options.subMenu.icon ? (
                  <img
                    src={resource.options.subMenu.icon}
                    className={classes.icon}
                  />
                ) : (
                  <ListIcon />
                )}
              </Grid>
              <Grid item className={classes.font}>
                {translate(`resources.${name}.name`)}
              </Grid>
              <Grid item xs={1} className={classes.arrowContainer}>
                {openedSubMenu !== idx ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowUpIcon />
                )}
              </Grid>
            </Grid>
          </MenuItem>
        )}
        <Collapse in={openedSubMenu === idx}>
          <MenuItem
            className={classes.disableHover}
            key={`submenu-collapsable-${resource.options.subMenu.name}-${idx}-${subIdx}`}
          >
            {!resource.options.path && (
              <MenuItemLink
                className={classes.disableHover}
                to={`/${resource.name}`}
                primaryText={
                  <Grid container spacing={2} className={classes.font}>
                    {open ? (
                      <Grid item>
                        {translate(
                          resource.options.label ||
                            `resources.${resource.name}.name`
                        )}
                      </Grid>
                    ) : (
                      <Grid item className={classes.font}>
                        {translate(
                          resource.options.label ||
                            `resources.${resource.options.subMenu.name}.name`
                        ).substring(0, 2)}
                      </Grid>
                    )}
                  </Grid>
                }
              />
            )}
            {resource.options.path && (
              <MenuItem
                key={`submenu-path-${resource.options.subMenu.name}-${idx}-${subIdx}`}
              >
                <a
                  target={resource.options.target | '_blank'}
                  href={resource.options.path}
                  className={`${classes.externalLink} ${classes.font}`}
                >
                  <Grid container spacing={2}>
                    {open ? (
                      <Grid item>
                        {translate(
                          resource.options.label ||
                            `resources.${resource.name}.name`
                        )}
                      </Grid>
                    ) : (
                      <Grid item>
                        {translate(
                          resource.options.label ||
                            `resources.${resource.options.name}.name`
                        ).substring(0, 2)}
                      </Grid>
                    )}
                  </Grid>
                </a>
              </MenuItem>
            )}
          </MenuItem>
        </Collapse>
      </>
    ))
  })
}

export default MyMenu
